import { ApolloClient, InMemoryCache, ApolloLink, createHttpLink, from } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
import awsmobile from '../config/aws-exports';
import { fetchAuthSession } from '@aws-amplify/auth';
import { handleApolloError } from '../util/handleApolloError';
import { resetUnstableNotice } from '../util/networkNoticeState';

const httpLink = createHttpLink({
  uri: awsmobile.aws_appsync_graphqlEndpoint,
});

const jwtString = (t) => {
  if (!t) return null;
  if (typeof t === 'string') return t;
  return t.toString?.() ?? null;
};

const authLink = setContext(async (_, { headers }) => {
  try {
    const session = await fetchAuthSession();
    const token =
      jwtString(session.tokens?.idToken) ?? jwtString(session.tokens?.accessToken);
    const next = { ...headers };

    if (token) {
      next.authorization = `Bearer ${token}`;
    } else if (awsmobile.aws_appsync_apiKey) {
      next['x-api-key'] = awsmobile.aws_appsync_apiKey;
    }

    return { headers: next };
  } catch (error) {
    return { headers };
  }
});

const errorLink = onError((errorResponse) => {
  handleApolloError(errorResponse);
});

const recoverOnSuccessLink = new ApolloLink((operation, forward) => (
  forward(operation).map((response) => {
    if (!response.errors?.length) {
      resetUnstableNotice();
    }
    return response;
  })
));

export const client = new ApolloClient({
  link: from([errorLink, recoverOnSuccessLink, authLink.concat(httpLink)]),
  cache: new InMemoryCache(),
});